import React, { useEffect, useRef, useState } from 'react';
import { classIf } from '../data/utils/classIf';
import { scrollToTarget } from '../data/utils/scrollToTarget';

function DateSelector(props) {
    const [expanded, setExpanded] = useState(false);

    function toggleExpand() {
        setExpanded(!expanded);
        if (expanded) {
            setTimeout(() => {
                if (navbar.current) {
                    const selected = navbar.current.querySelector('.selected');
                    scrollToTarget(navbar.current, selected);
                }
            }, 200);
        }
    }

    const navbar = useRef(null);
    useEffect(() => {
        if (navbar.current) {
            const selected = navbar.current.querySelector('.selected');
            if (navbar.current.firstElementChild !== selected) {
                navbar.current.scrollLeft = selected.getBoundingClientRect().left;
            }
        }
    }, []);

    return (
        <nav className="nav-filters-wrapper">
            <div className={"nav-filters" + classIf(expanded, 'expanded')} ref={navbar}>
                {props.dates.map(date => {
                    function handleClick(e) {
                        props.changeDate(date.DBDate);
                        if (expanded) {
                            setExpanded(!expanded);
                            setTimeout(() => {
                                if (navbar.current) {
                                    scrollToTarget(navbar.current, e.target);
                                }
                            }, 200);
                        }
                    }
                    const selected = props.date === date.DBDate;
                    return <div key={date.DBDate} className={"nav-filter-item" + classIf(selected, 'selected')} onClick={handleClick}>{date.date}</div>
                })}
                {expanded &&
                    <div className="nav-filters-close-button" onClick={toggleExpand}>
                        <i className="far fa-times-circle"></i>
                    </div>
                }
            </div>
            {props.dates.length > 3 &&
                <div className="nav-filters-expand-button" onClick={toggleExpand}>
                    <i className="fa fa-angle-down"></i>
                </div>
            }
        </nav>
    );
}

export default DateSelector;